import { ModalData } from 'utils/ModalHelpers'
import GlobalModalConstants from 'constants/GlobalModalConstants'

class GlobalModalActions extends Marty.ActionCreators {
  openModal(title, description, onConfirm, onCancel, buttonProps, confirm="Yes, Continue") {
    this.dispatch(GlobalModalConstants.MODAL_OPENED, ModalData({title, description, onConfirm, onCancel, buttonProps, confirm}))
  }

  closeModal() {
    this.dispatch(GlobalModalConstants.MODAL_CLOSED)
  }
}

export default GlobalModalActions



// WEBPACK FOOTER //
// ./src/scripts/actions/GlobalModalActions.js